import http from '../utils/http'
import joinUrls from '../utils/join-urls'

export default {
	send(data) {
		return http.post(joinUrls('/sys-events'), data);
	}
}